import React from 'react';
import { Checkbox, Form, Input } from 'antd';

type Options = {
  input?: any;
  getName: (record: any, index: number) => (string | number)[];
  componentProps?: object;
  itemProps?: object;
  style?: object;
};

export default function createEditableCell(options: Options) {
  const { getName, input, componentProps, itemProps, style } = options;

  const InputComponent = input ?? Input;

  const itemExtraProps: any = {};
  if (InputComponent === Checkbox) {
    itemExtraProps.valuePropName = 'checked';
  }

  return (value: any, record: any, index: number) => {
    return (
      <Form.Item noStyle name={getName(record, index)} {...itemProps} {...itemExtraProps}>
        <InputComponent style={style} {...componentProps} />
      </Form.Item>
    );
  };
}
